module.exports = __webpack_public_path__ + "img/mateu_background_hero.a0fa98fc.png";